import apiClient from '../../apis/apiClient';
import { getServerUrl } from '../../utils';

export const get = (url) => {
  return apiClient(getServerUrl()).get(url);
};

export const post = (url, payload) => {
  return apiClient(getServerUrl()).post(url, payload);
};

export const put = (url, payload) => {
  return apiClient(getServerUrl()).put(url, payload);
};

export const remove = (url,payload) => {
  return apiClient(getServerUrl()).delete(url, { data: payload ? payload : {} });
};
